export const browserActions = [
  {
    name: 'switchEntity',
    label: 'Switch Collection (Browser Storage)',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'updateEntityBy',
        label: 'Get Collection By',
        type: 'dropdown',
        options: [],
        value: 'byCollectionUuid',
      },
      {
        name: 'storageCustomKey',
        label: 'Custom JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'storageCustomKeyLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'setBrowserStorageData',
    label: 'Set Data in Browser Storage',
    args: [
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'customJsonKey',
        label: 'Custom JSON Key',
        placeholder: 'Custom JSON Key (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'customJsonValue',
        label: 'Custom JSON Value',
        placeholder: 'Custom JSON Value (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'clearBrowserStorageData',
    label: 'Remove Data from Browser Storage',
    args: [
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'removeAllData',
        label: 'Remove All Data',
        type: 'boolean',
        value: '',
        custom: [],
      },
      {
        name: 'removeSelectedKeys',
        label: 'Remove Selected Key(s)',
        placeholder: 'Eg. Key1 or, Key1,Key2,Key3',
        type: 'text',
        value: '',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
];
